import React from 'react';
import toast from 'react-hot-toast';
import { createBudget, getBudgetHistory, updateBudget } from '../../../backend-services';
import { validateBudgetForm } from '../../../modules/settings/settings';
import PageLoader from '../../common/PageLoader';
import { CreateBudget } from './create';
import { EditBudget } from './edit';
import { ViewBudget } from './view';

interface Props {
  submenuTab: string;
  onBack: () => void;
  budgetSubmenuTab: string;
}

export const BudgetManager: React.FC<Props> = ({ submenuTab, onBack }) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [showSuccessModal, setShowSuccessModal] = React.useState(false);
  const [budgetSet, setBudgetSet] = React.useState(false);
  const [showDrawer, setShowDrawer] = React.useState(false);
  const [, setErrorMessage] = React.useState<string>('');
  const [isUpdating, setIsUpdating] = React.useState(false);
  const [showBudget, setShowBudget] = React.useState(false);
 

  const [formData, setFormData] = React.useState({
    monthYear: '',
    allocatedBudget: 0,
  });

  const [validationResults, setValidationResults] = React.useState({
    monthYear: '',
    allocatedBudget: 0,
  })

  const handleCreateBudget = async () => {
    setIsLoading(true);
    try {
      const monthYearPattern = /^(0[1-9]|1[0-2])-(19|20)\d\d$/;
      const isValidMonthYear = monthYearPattern.test(formData.monthYear);

      if (!isValidMonthYear) {
        setErrorMessage('Invalid monthYear format');
        return;
      }

      const data = {
        ...formData,
        allocatedBudget: Number(formData.allocatedBudget),
        monthYear: formData.monthYear,
      };
      const result = await createBudget(data);
      console.log(result);
      setShowSuccessModal(true);
    } catch (error) {
      console.log(error);
      setErrorMessage('Unable to create.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleBudgets = async () => {
    setIsLoading(true);
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();
    const monthYear = `${currentMonth.toString().padStart(2, '0')}-${currentYear}`;
  
    try {
      const data = await getBudgetHistory(monthYear, monthYear);
      setIsLoading(false);
  
      const budgetForMonthYear = data.find(
        (formData: { monthYear: string }) => formData.monthYear === monthYear
      );
  
      if (budgetForMonthYear) {
        setFormData({
          monthYear: budgetForMonthYear.monthYear,
          allocatedBudget: budgetForMonthYear.allocatedBudget,
        });
      }
    } catch (e) {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    handleBudgets();
  }, []);

  const handleUpdateBudget = async (e: any) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1;
      const currentYear = currentDate.getFullYear();
  
      const [month, year] = formData.monthYear.split('-').map(Number);
  
      if (month === currentMonth && year === currentYear) {
        const updatedData = {
          monthYear: formData.monthYear,
          allocatedBudget: Number(formData.allocatedBudget),
        };
  
        console.log('Updated budget data:', updatedData);
        await updateBudget(updatedData);
  
        setShowBudget(true);
        setShowSuccessModal(true);
        setShowDrawer(true);
  
       
        setFormData((prevState) => ({
          ...prevState,
          allocatedBudget: updatedData.allocatedBudget,
          monthYear: updatedData.monthYear,
        }));
      } else {
        setErrorMessage('Updates are only allowed for the current month.');
      }
    } catch (error) {
      console.log(error);
      setErrorMessage('Unable to update.');
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsLoading(true);
    const errorFound = validateBudgetForm(formData, setValidationResults);
    if (!errorFound) {
      if (isUpdating) {
        handleUpdateBudget(event);
      } else {
        handleCreateBudget();
      }
    }
    setIsLoading(false);
  }

  const renderBudget = () => {
    if (formData.monthYear) {
      return (
        <ViewBudget
          monthYear={formData.monthYear}
          allocatedBudget={formData.allocatedBudget}
        />
      );
    } else {
      return (
        <>
          <CreateBudget onSubmit={handleSubmit} isLoading={isLoading} />
          {isUpdating && (
            <EditBudget onSubmit={handleUpdateBudget} isLoading={isLoading} monthYear="" allocatedBudget={undefined} />
          )}
        </>
      );
    }
  };

  return (
    <div>
      {isLoading ? (
        <PageLoader />
      ) : (
        <>
          {renderBudget()}
        </>
      )}
    </div>
  );
}
